import type { Store, StoreProvider } from "@hobbyshopify/backend-client";
import { Rx } from "subtree.js/core";

export class SetupChecklistState {
  readonly store = new Rx<Store | null>(null);
  /** Null until the providers have answered once for this shop; `stripeKnown` says whether they have. */
  readonly stripe = new Rx<StoreProvider | null>(null);
  readonly stripeKnown = new Rx(false);
  /** A "Check again" asking Stripe is in flight. */
  readonly checking = new Rx(false);
  readonly checkError = new Rx<string | null>(null);
}

export abstract class SetupChecklistActions {
  /** Asks Stripe for the account's status now, instead of waiting for the next poll. */
  abstract checkAgain(): Promise<void>;
}
